import script from "./TheLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLogin.vue?vue&type=script&setup=true&lang=js"

import "./TheLogin.vue?vue&type=style&index=0&id=12614a28&lang=css"

const __exports__ = script;

export default __exports__